// import React, { useEffect, useState } from "react";
// import notification from "../../assets/img/notification.svg";
// import user_icon from "../../assets/img/user_icon.svg";
// import { NavLink, useNavigate } from "react-router-dom";
// import Dropdown from "react-bootstrap/Dropdown";
// import down_icon from "../../assets/img/down_icon.svg";
// import { useDispatch, useSelector } from "react-redux";
// import { getProfile } from "../../redux/GetProfileSlice";


// const Header = () => {
//   const [profileData, setProfileData] = useState({});
//   const navigation = useNavigate();
//   const dispatch = useDispatch();
//   const profileResponse = useSelector((state) => state.getProfileReducer.data);
//   const [selectedItem, setSelectedItem] = useState();

//   useEffect(() => {
//     dispatch(getProfile());
//   }, []);
//   useEffect(() => {
//     if (profileResponse != null && profileResponse.status === 1) {
//       setProfileData(profileResponse.data);
//     }
//   }, [profileResponse]);

//   const handleSelect = (eventKey) => {
//     setSelectedItem(eventKey);
//   };

//   return (
//     <div className="header header-with-data">
//       <div className="user-info">
//         <img
//           src={notification}
//           style={{ cursor: "pointer" }}
//           alt="notification"
//           className="notification-icon"
//         />
//         {profileData?.picture ? (
//           <img
//             src={profileData?.picture}
//             alt="user_icon "
//             className="user-icon google-img"
//             style={{ cursor: "pointer" }}
//             onClick={() => navigation("/ProfileHeader")}
//           />
//         ) : (
//           <img
//             src={user_icon}
//             alt="user_icon"
//             className="user-icon"
//             style={{ cursor: "pointer" }}
//             onClick={() => navigation("/ProfileHeader")}
//           />
//         )}

//         <div className="user-data">
//           <Dropdown onSelect={handleSelect}>
//             <Dropdown.Toggle variant="success" id="dropdown-basic">
//               <img src={down_icon} alt="down_icon" />
//             </Dropdown.Toggle>
//             <Dropdown.Menu>
//               <Dropdown.Item eventKey="ContactUs">
//                 <NavLink to="/ContactUs">Contact Us</NavLink>
//               </Dropdown.Item>
//               <Dropdown.Item eventKey="About">
//                 <NavLink to="/About">About Us</NavLink>
//               </Dropdown.Item>
//               {profileData.role === 'User' && <Dropdown.Item eventKey="AddCompany">
//                 <NavLink to="/Company">Company</NavLink>
//               </Dropdown.Item>}
//               {profileData.role === 'User' && <Dropdown.Item eventKey="Employee">
//                 <NavLink to="/employee">Employee</NavLink>
//               </Dropdown.Item>}
//               {profileData.role === 'User' && <Dropdown.Item eventKey="AddCompany">
//                 <NavLink to="/subscription-plans">Subscription Plans</NavLink>
//               </Dropdown.Item>}
//             </Dropdown.Menu>
//           </Dropdown>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;




import React, { useEffect, useState, useRef } from "react";
import notification from "../../assets/img/notification.svg";
import user_icon from "../../assets/img/user_icon.svg";
import { NavLink, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import down_icon from "../../assets/img/down_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../redux/GetProfileSlice";

const Header = () => {
  const [profileData, setProfileData] = useState({});
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const profileResponse = useSelector((state) => state.getProfileReducer.data);
  const [selectedItem, setSelectedItem] = useState();

  useEffect(() => {
    dispatch(getProfile());
  }, []);
  useEffect(() => {
    if (profileResponse != null && profileResponse.status === 1) {
      setProfileData(profileResponse.data);
    }
  }, [profileResponse]);

  const handleSelect = (eventKey) => {
    setSelectedItem(eventKey);
  };

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="header header-with-data">
      <div className="user-info">
        <img
          src={notification}
          style={{ cursor: "pointer" }}
          alt="notification"
          className="notification-icon"
        />

        {profileData?.picture ? (
          <img
            src={profileData?.picture}
            alt="user_icon "
            className="user-icon google-img"
            style={{ cursor: "pointer" }}
            onClick={() => navigation("/ProfileHeader")}
          />
        ) : (
          <img
            src={user_icon}
            alt="user_icon"
            className="user-icon"
            style={{ cursor: "pointer" }}
            onClick={() => navigation("/ProfileHeader")}
          />
        )}
        {profileData && <p style={{color: "#0F0F0F", fontSize: "15px", fontWeight: 500}}>{profileData?.email || `${profileData.firstName} ${profileData.lastName}` }</p>}
        <div className="user-data">
          <div className="dropdown" ref={dropdownRef}>
            <button onClick={toggleDropdown} className="dropdown-toggle-btn">
              <img src={down_icon} alt="down_icon" />
            </button>

            {isOpen && (

              <div className="dropdown-menu show">
                {profileData.role === 'User' && (
                  <>
                    <div className="dropdown-item">
                      <NavLink to="/Company" onClick={() => setIsOpen(false)}>Company</NavLink>
                    </div>
                    <div className="dropdown-item">
                      <NavLink to="/employee" onClick={() => setIsOpen(false)}>Users</NavLink>
                    </div>
                    <div className="dropdown-item">
                      <NavLink to="/subscription-plans" onClick={() => setIsOpen(false)}>Subscription Plans</NavLink>
                    </div>
                  </>
                )}
                <div className="dropdown-item">
                  <NavLink to="/ContactUs" onClick={() => setIsOpen(false)}>Contact Us</NavLink>
                </div>
                <div className="dropdown-item">
                  <NavLink to="/About" onClick={() => setIsOpen(false)}>About Us</NavLink>
                </div>

              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;

